import { Pipe, PipeTransform } from '@angular/core';
import { getFormatedCurrency } from '@app/utils/utils';

@Pipe({
  name: 'portalCurrency',
})
export class PortalCurrencyPipe implements PipeTransform {
  transform(value: number, isFractionClass = false): string {
    value = value || 0;
    const formattedCurrency = getFormatedCurrency(value, 'USD', 'en-US');
    const [main, fraction] = formattedCurrency.split('.');
    let result = `${main}`;

    if (fraction) {
      if (isFractionClass) {
        result += `.<span class="currency-fraction">${fraction}</span>`;
      } else {
        result += `.${fraction}`;
      }
    }

    return result;
  }
}
